class FilterController {
  constructor(items, controls, noResults) {
    this.noResults = noResults
    this.selected = {}
    this.items = Array.from(items)
    this.buttonGroup = Array.from(controls).reduce((obj, el) => {
      const key = el.dataset.type

      if ( ! Object.keys(obj).includes(key) ) {
        obj[key] = el.querySelectorAll('.portfolio__control')
      }

      return obj
    }, {})
  }

  initialFilter(init) {
    for (const [k, v] of init) {      
      const btn = document.querySelector(`#control-${v}`)
      this.selected[k] = v
      this.indicate(k, btn)
    }
    this.filter()
  }

  initializeControls() {
    Object.values(this.buttonGroup).forEach(group => {
      group.forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.key
          const value = btn.dataset.value

          if (value.includes('clear')) {
            if ( value.includes('all')) this.resetAll()
            else this.reset(key)
          } else {
            btn.dataset.selected === '1'
              ? this.reset(key)
              : this.select(key, value, btn)
          }
        })
      })
    })
  }

  select(key, value, btn) {
    this.selected[key] = value
    this.filter()
    this.indicate(key, btn)
  }

  reset(key) {
    this.selected[key] = ''
    this.filter();
    this.removeIndication(key)
  }

  resetAll() {
    Object.keys(this.selected).forEach(k => this.selected[k] = '')
    this.filter()
    this.removeAllIndication()
  }

  removeAllIndication() {
    Object.values(this.buttonGroup).forEach(group => 
      group.forEach(btn => 
        btn.dataset.selected = '0' 
      )
    )
  }

  removeIndication(type) {
    this.buttonGroup[type].forEach(el => el.dataset.selected = '0' )
  }

  indicate(type, selected) {
    Object.entries(this.buttonGroup).forEach(([key, group]) => {
      if ( key === type ) {
        group.forEach(btn => btn.id === selected.id 
          ? btn.dataset.selected = '1'
          : btn.dataset.selected = '0'
        )
      }
    })
  }

  filter() {
    const keys = Object.keys(this.selected)
    /**
     * Step through ALL of the items
     * Mapping over keys, 
     *  We take the element's data-[key] attribute
     *  We split that attribute over ' '
     *  We take that array and check if it includes this.selected[key]
     *  Return that value
     * Reduce the result into shouldShow
     *  If EVERY element in the result array is true, 
     *    then return true. 
     *    Else, return false
     * 
     * If shouldShow,
     *  then set it's data-showing attribute to "1"
     * Else
     *  set it's data-showing attribute to "0"
     */
    this.items.forEach(item => {
      const shouldShow = keys.map( key => {
        if ( this.selected[key].length > 0 ) {
          return item.dataset[key].split(' ').includes(this.selected[key])
        } else {
          return true
        }
      })
      .reduce((acc, res) => res ? acc : res, true )

      if ( shouldShow ) {
        item.dataset.showing = "1"
      } else {
        item.dataset.showing = "0"
      }
    })

    this.checkForEmpty()
  }

  checkForEmpty() {
    const noResults = this.items.reduce((acc, item) => 
      item.dataset.showing === "1" ? false : acc,
      true
    )

    if ( noResults ) {
      this.noResults.dataset.showing = "1"

      let msg = Object.entries(this.selected).reduce((txt, [k, v]) => {
        txt += ` ${k} &`
        return txt
      }, 'There is no result for that')
      msg = msg.slice(0, -2).concat(' combination')
      
      this.noResults.querySelector('.message').innerHTML = msg
    } else {
      this.noResults.dataset.showing = "0"
    }
  }
}

export { FilterController }